import React from "react";
import { Badge, IconButton, Tooltip } from "@material-ui/core";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { primary, red } from "../../styles/colors";

const DuePaymentsIcon = ({ urgentCount, onClick }) => {
  const hasUrgent = urgentCount > 0;

  return (
    <Tooltip title={`Due Payments (${urgentCount} urgent)`} placement="bottom">
      <IconButton
        onClick={onClick}
        style={{
          backgroundColor: "white",
          color: primary,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease",
          // boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          // border: `2px solid ${primary}`,
        }}
        size="medium"
      >
      <Badge color="primary"  variant="dot"  badgeContent={true}
          max={99}
          // overlap="circular"
            style={{
            // "& .MuiBadge-badge .MuiBadge-anchorOriginTopRightCircular": {
            //   top: "-10%",
            //   right: "-10%",
            // }
            }}
          >
        <AccountBalanceWalletIcon sx={{ color: primary}} />
      </Badge>
        {/* <Badge
          badgeContent={urgentCount}
          max={99}
          overlap="circular"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{
            "& .MuiBadge-badge": {
              top: "-17%",
              right: "-11%",
              minWidth: "20px",
              height: "20px",
              fontSize: "10px",
              fontWeight: 600,
              backgroundColor: primary,
              color: "white",
              boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
            },
          }}
        >
          <CurrencyRupeeIcon style={{ fontSize: 22 }} />
        </Badge> */}
      </IconButton>
    </Tooltip>
  );
};

export default DuePaymentsIcon;
